<input [style.color]="fontColor" type="text" [value]="value" #input style="width: 100%" (keydown)="getInputValues()">
